import React, { useCallback } from "react";
import InputField from "../InputField";
import FieldWithSelectOrAutoComplete from "./FieldWithSelectOrAutoComplete";
import { Box } from "@mui/material";
import { normalizeFormErrors } from "../../utils/objectUtils";

const inputTypes = [
  "text",
  "textarea",
  "email",
  "color",
  "password",
  "number",
  "date",
  "month",
  "checkbox",
  "file",
];

const SimpleBody = ({
  fields,
  formErrors,
  formData,
  handleFieldChange,
  getOptions,
  getSelectedValue,
  getSelectMeta,
}) => {
  const handleSelectOrAutoCompleteChange = useCallback(
    (fieldIdFromChild, selectedOption) => {
      handleFieldChange(fieldIdFromChild, selectedOption);
    },
    [handleFieldChange],
  );

  function getError(formErrors, fieldId) {
    return (
      fieldId.split(".").reduce((acc, key) => acc?.[key], formErrors) || ""
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
        columnGap: 2,
        rowGap: 1,
      }}>
      {fields.map((field) => {
        const [category, key] = field.id.split(".");
        const fieldValue =
          category && key
            ? (formData?.[category]?.[key] ?? "")
            : (formData?.[field.id] ?? "");

        const colSpan = field.fullWidth ? "span 2" : "span 1";

        return (
          <Box key={field.id} sx={{ gridColumn: colSpan }}>
            {inputTypes.includes(field.type) ? (
              <InputField
                label={field.label}
                type={field.type}
                id={field.id}
                value={fieldValue ?? ""}
                views={field.views}
                inputFormat={field.inputFormat}
                icon={field.icon}
                onChange={(e) => {
                  if (e && e.target) {
                    handleFieldChange(field.id, e.target.value);
                  }
                }}
                placeholder={field.placeholder}
                error={getError(formErrors, field.id)}
                disabled={field.disabled}
                mask={field.mask}
                isNumericFormat={field.isNumericFormat}
                formatType={field.formatType}
                maxLength={field.maxLength}
                withHours={field.withHours}
                useDateTime={field.useDateTime}
              />
            ) : (
              <FieldWithSelectOrAutoComplete
                field={field}
                formData={formData}
                formErrors={normalizeFormErrors(formErrors)}
                onFieldChange={handleSelectOrAutoCompleteChange}
                getOptions={getOptions}
                getSelectedValue={getSelectedValue}
                getSelectMeta={getSelectMeta} // NOVO
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default SimpleBody;
